import { cn } from '@/utils';
import { Button } from '@/components/ui/button';

import Spinner from './Spinner';

const SpinnerButton = ({ onClick, loading, className, children, ...rest }) => {
  return (
    <Button
      onClick={onClick}
      disabled={loading}
      className={cn(className)}
      {...rest}
    >
      <div className="flex justify-center items-center w-full relative">
        {loading && <Spinner className="absolute left-0" />}
        <span>{children}</span>
      </div>
    </Button>
  );
};

export default SpinnerButton;
